import { fg } from '@atlassian/jira-feature-gating';
import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';

const sessionStorageProvider = createSessionStorageProvider('', false);

const SHOW_NEW_EDITOR_SUCCESS_FLAG = 'SHOW_NEW_EDITOR_SUCCESS_FLAG';
const SHOW_OLD_EDITOR_ERROR_FLAG = 'SHOW_OLD_EDITOR_SUCCESS_FLAG';

// New editor success flag
const updateShowNewEditorSucccessFlag = (value: boolean) => {
	fg('jfp-vulcan-browser-storage-migration')
		? sessionStorageProvider.set(SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString())
		: sessionStorage.setItem(SHOW_NEW_EDITOR_SUCCESS_FLAG, value.toString());
};

export const getShouldShowNewEditorSucccessFlag = (): boolean =>
	fg('jfp-vulcan-browser-storage-migration')
		? Boolean(sessionStorageProvider.get(SHOW_NEW_EDITOR_SUCCESS_FLAG))
		: Boolean(sessionStorage.getItem(SHOW_NEW_EDITOR_SUCCESS_FLAG));

export const setShowNewEditorSuccessFlag = (): void => {
	updateShowNewEditorSucccessFlag(true);
};

export const clearShowNewEditorSucccessFlag = (): void => {
	fg('jfp-vulcan-browser-storage-migration')
		? sessionStorageProvider.remove(SHOW_NEW_EDITOR_SUCCESS_FLAG)
		: sessionStorage.removeItem(SHOW_NEW_EDITOR_SUCCESS_FLAG);
};

// Old editor success flag
const updateShowOldEditorSucccessFlag = (value: boolean) => {
	fg('jfp-vulcan-browser-storage-migration')
		? sessionStorageProvider.set(SHOW_OLD_EDITOR_ERROR_FLAG, value.toString())
		: sessionStorage.setItem(SHOW_OLD_EDITOR_ERROR_FLAG, value.toString());
};

export const getShouldShowOldEditorSucccessFlag = (): boolean =>
	fg('jfp-vulcan-browser-storage-migration')
		? Boolean(sessionStorageProvider.get(SHOW_OLD_EDITOR_ERROR_FLAG))
		: Boolean(sessionStorage.getItem(SHOW_OLD_EDITOR_ERROR_FLAG));

export const clearShowOldEditorSucccessFlag = (): void => {
	fg('jfp-vulcan-browser-storage-migration')
		? sessionStorageProvider.remove(SHOW_OLD_EDITOR_ERROR_FLAG)
		: sessionStorage.removeItem(SHOW_OLD_EDITOR_ERROR_FLAG);
};

export const setShowOldEditorSuccessFlag = (): void => {
	updateShowOldEditorSucccessFlag(true);
};
